<template>
  <v-dialog v-model="intDialogVisible" max-width="600px" class="addValueModal addComment">
    <v-card>
      <v-card-title>
        <h3 class="primary--text formName">Send by email</h3>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3"  @submit.prevent="submit">
            Recipient
            <v-text-field v-model="recipient" class="addValueInput"></v-text-field>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="close" >
              Close
            </v-btn>
            <v-btn class="addValue" @click="submit" >
              Send
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/tools/api';
  import { toast } from 'vue-sonner'
export default {
  props: {
    dialogVisible: Boolean,
    formName: String,

  },
  data () {
    return{
      recipient:'',
    }
  },
  methods:{
    submit(){
        var r = this.recipient.split(',');
        var error = false;
        r.forEach((item) => {

            if(item.trim().toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) == null){
              error=true;
            }
        });
        console.log(error);
        if(error == false){
          this.$emit('newValueIsProposed',this.recipient)
        }
        else{
          toast.error("Input contains one or more invalid email. Please check your input")
        }

    },
    close(){
        this.$emit('close',false)
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    }
  },
  watch: {
    dialogVisible: function(){
      api.get(process.env.VUE_APP_API_URL+"/restrict/myaccount").then( (r) => {
        console.log(r.data);
        this.recipient = r.data.email;
      });
    }
  }

}
</script>

<style media="screen" scoped>
  .addValueModal .v-card{
    padding:10px;
  }
  .addValueModal .v-field__outline{
    display:none;
  }
  .formName{
    text-align: left;
    font-size: 21px;
    line-height: 25px;
    color: #3783C5;
  }
  .addValueModal button{
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 7px 18.5px;
    color:#3783C5;
    margin: 5px;
  }

    .addValueModal button.addValue{
      border: 1px solid #3783C5;

      background:#3783C5;
      color:#fff;
    }

    .addValueInput input{
      border: 1px solid #DDDDDD;
    }
  .addComment textarea{
    width: 100%;
margin: 0;
border: 1px solid #DDDDDD;
mask-image: none !important;
  }
  .v-card-title{
    white-space: normal !important;
  }
</style>
